/* eslint-disable */

import React from "react";
import moment from "moment";
import APIClient from "../client";
import { Spinner } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

const { SearchBar } = Search;

class Jobs extends React.Component {
  static defaultProps = {
    columns: ["external_service_id", "machines", "records", "date", "status"],
  };

  state = {
    jobs: null,
  };

  constructor(props, context) {
    super(props, context);
    this.loadJobs();
  }

  async downloadJob(jobId) {
    try {
      const response = await APIClient.get(
        "/api/data/jobs/" + jobId + "/download/",
        null,
        cropr.cloudfarm_oauth_token
      );
      window.open(response, "_blank");
    } catch {
      cropr.notify("danger", gettext("Jobs could not be loaded."));
    }
  }

  async loadJobs() {
    try {
      const response = await APIClient.get(
        "/api/data/jobs/",
        { online_service: this.props.online_service },
        cropr.cloudfarm_oauth_token
      );
      this.setState({ jobs: response });
    } catch {
      cropr.notify("danger", gettext("Jobs could not be loaded."));
    }
  }

  render() {
    let columns = [
      {
        dataField: "id",
        hidden: true,
      },
    ];
    columns = columns.concat(
      this.props.columns.map((c) => {
        switch (c) {
          case "external_service_id":
            return {
              text: "ID",
              dataField: "external_service_id",
              sort: true,
              formatter: (c, t) => (
                <a
                  href="#"
                  className="w-100 d-inline-block overflow-hidden text-truncate"
                  title={t.external_service_id}
                  onClick={() => this.downloadJob(t.id)}
                >
                  {t.external_service_id}
                </a>
              ),
            };
          case "machines":
            return {
              text: gettext("Machines"),
              dataField: "a", //arrays niet geschikt als key of zo
              sort: true,
              formatter: (c, t) => t.machines.map((m) => cropr.getDeviceName(m)).join(", "),
            };
          case "records":
            return {
              text: gettext("Records"),
              dataField: "b", //arrays niet geschikt als key of zo
              sort: true,
              formatter: (c, t) =>
                (t.task_ids || []).map((r, i) => (
                  <>
                    {i > 0 ? ", " : null}
                    {cropr.records.get(parseInt(r)) ? (
                      <a href={"/cropr/record/record/#edit/" + r} target="_blank">
                        {r}
                      </a>
                    ) : (
                      r
                    )}
                  </>
                )),
            };
          case "date":
            return {
              text: gettext("Date"),
              dataField: "send_datetime",
              sort: true,
              formatter: (c, t) =>
                moment(t.received_datetime || t.send_datetime).format("YYYY-MM-DD HH:mm:ss"),
            };
          case "status":
            return {
              text: gettext("Status"),
              dataField: "status",
              sort: true,
              formatter: (c, t) => (
                <span
                  title={
                    cf_job_states[t.status_text] ? cf_job_states[t.status_text].description : ""
                  }
                >
                  {gettext(t.status_text)}
                </span>
              ),
            };
        }
      })
    );
    return this.state.jobs ? (
      this.state.jobs.length ? (
        <ToolkitProvider
          keyField="id"
          data={this.state.jobs}
          columns={columns}
          bootstrap4={true}
          search={{
            searchFormatted: true,
          }}
        >
          {(props) => (
            <>
              <div className="dataTables_filter">
                <SearchBar placeholder={gettext("Search")} {...props.searchProps} />
              </div>

              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory({ bootstrap4: true })}
                keyField="id"
              />
            </>
          )}
        </ToolkitProvider>
      ) : (
        <div className="text-center m-5">{gettext("No jobs found for this account.")}</div>
      )
    ) : (
      <div className="text-center m-5">
        <Spinner animation="border" role="status">
          <span className="sr-only mx-auto">Loading...</span>
        </Spinner>
      </div>
    );
  }
}

const cf_job_states = {
  "Error sending": {
    text: gettext("Error sending"),
    description: gettext("An error occurred when sending this job."),
  },
  Send: { text: gettext("Sent"), description: gettext("Job has been sent.") },
  Pending: {
    text: gettext("Pending"),
    description: gettext("Job is pending to be sent to the tractor."),
  },
  "Conversion failed": {
    text: gettext("Conversion failed"),
    description: gettext("The task could not be converted to the appropriate format."),
  },
  Queued: {
    text: gettext("Queued"),
    description: gettext("Job is queued for downloading by the tractor."),
  },
  Processing: { text: gettext("Processing"), description: gettext("Job is being processed.") },
  Failed: { text: gettext("Failed"), description: gettext("Job transfer has failed.") },
  Delivered: {
    text: gettext("Delivered"),
    description: gettext("Job has been delivered to the tractor."),
  },
  Canceled: { text: gettext("Canceled"), description: gettext("Job has been canceled.") },
  "Error receiving": {
    text: gettext("Error receiving"),
    description: gettext("An error occurred receiving task data."),
  },
  Received: {
    text: gettext("Received"),
    description: gettext("Task data has been received from the tractor."),
  },
  Expired: { text: gettext("Expired"), description: gettext("Task has timed out.") },
};

export default Jobs;
